export enum ConnectTypes {
  FRANCE_CONNECT = 'FranceConnect',
  PRO_CONNECT = 'ProConnect',
}
